import { Component, OnInit, Inject } from '@angular/core';
import { SupplementaryEquipment, SupplementaryEquipmentHandout } from '../model/supplementary-equipment-take-back.model';
import { MAT_DIALOG_DATA, MatDialogRef  } from '@angular/material/dialog';
import { AppServerAPI, Identity } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';

@Component({
  selector: 'app-tmc-supplementary-equipment-take-back',
  templateUrl: './supplementary-equipment-take-back.component.html',
  styleUrls: ['./supplementary-equipment-take-back.component.scss']
})
export class SupplementaryEquipmentTakeBackComponent implements OnInit {

  handout = new SupplementaryEquipmentHandout();
  isLoading = false;

  identity;

  formGroup = new FormGroup({});

  constructor(
    public dialogRef: MatDialogRef<SupplementaryEquipmentTakeBackComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appServerAPI: AppServerAPI,
    public translationService: TranslationService) {

    this.isLoading = true;
    this.identity = new Identity();
    this.identity.id = data.visitId;

  }

  ngOnInit() {
    this.appServerAPI.execute<SupplementaryEquipmentHandout>(`/client/visit/control/supplementaryequipment/takeback/details`, this.identity)
      .subscribe(response => {
        this.isLoading = false;
        this.handout = response;
        this.setupForm();
      }, error => {
        this.isLoading = true;
        console.error(error);
      });
  }

  private setupForm() {
    this.handout.supplementaryEquipments.forEach( (se, index) => {
      const equipmentFormGroup = new FormGroup({
        index: new FormControl(index),
        selected: new FormControl(se.selected),
        identifier: new FormControl(se.identifier),
        parameter1Value: new FormControl(se.parameter1Value)
      });
      this.formGroup.addControl(se.key + index, equipmentFormGroup);
      equipmentFormGroup.controls.identifier.disable();
      equipmentFormGroup.controls.parameter1Value.disable();
      equipmentFormGroup.valueChanges.subscribe(values => {
        this.handout.supplementaryEquipments[values.index].selected = values.selected;
      });
    });

  }

  supplementaryEquipmendHandouted(handout: SupplementaryEquipmentHandout): boolean {
    return handout.supplementaryEquipments != null && handout.supplementaryEquipments.length > 0;
  }

  isParam1Available(se: SupplementaryEquipment) {
    return se.parameter1Value !== null;
  }

  isSaveDisabled(): boolean {

    if (this.isLoading) {
      return true;
    }

    return false;
  }

  cancel() {
    this.dialogRef.close();
  }

  save() {
    this.isLoading = true;
    this.appServerAPI.execute<any>(`/client/visit/control/supplementaryequipment/takeback/save`, this.handout)
      .subscribe(response => {
        this.isLoading = false;
        this.dialogRef.close();
      }, error => {
        this.isLoading = false;
        console.log(error);
      });
  }

  isFormReadonly() {
    return this.isLoading;
  }
}
